import { render } from "./FeaturedSlides.vue?vue&type=template&id=6ce7c196"
import script from "./FeaturedSlides.vue?vue&type=script&lang=js"
export * from "./FeaturedSlides.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/clients/inmaat/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__